<template>
  <div>
    <slot name="header"></slot>

    <div class="container-fluid content-course-page">
      <v-row>
        <v-col v-if="course.videoIntro && course.videoIntro.vimeoStatus === 'complete'" cols="12" sm="12" md="12"
               class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
               data-wow-offset="40">
          <div class="video">
            <span class="intro-video">Introdução do curso</span>
            <div id="playerInfo"></div>
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="6" class="content wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
               data-wow-offset="40">
          <h4>Conteúdo do curso</h4>
          <div class="content-tabs">
            <v-expansion-panels focusable :aria-expanded="true" v-if="course.modules.length">
              <v-expansion-panel
                v-for="(module,i) in course.modules"
                :key="`mod${i}`"
              >
                <v-expansion-panel-header>{{ module.title }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-hover v-slot:default="{ hover }" v-for="(content,k) in module.contents" :key="`modc${k}`">
                    <div @click="openContent(content)"
                         :style="(content.isPublic ? '' : 'cursor: no-drop')"
                         class="item-list">
                      {{ content.title }}
                    </div>
                  </v-hover>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-container v-if="course.contents.length">
              <v-row>
                <v-col cols="12"
                       v-for="(content,i) in course.contents"
                       :key="`c${i}`"
                       class="py-4 mb-4 success white--text elevation-3"
                       @click="openContent(content)"
                       :style="(content.vimeoId && content.vimeoStatus === 'complete' ? 'cursor:pointer' : 'cursor:no-data')"
                >
                  {{ content.title }}
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>

        <v-col cols="12" sm="12" md="6" class="summary wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
               data-wow-offset="40" v-if="showDescription">
          <h4>{{ titleDescription }}</h4>
          <div
            :class="fullDescription || description.length <= 1490 ? 'active render-content' : 'render-content'">
            <p v-html="description"></p>
            <v-btn v-if="description.length > 1490" class="outline w100" color="primary" dark
                   @click="fullDescription = !fullDescription">
              <template v-if="fullDescription">
                Ver menos
              </template>
              <template v-else>
                Ver descrição completa
              </template>
            </v-btn>
          </div>
        </v-col>

        <!--<v-col cols="12" sm="12" md="6" class="summary wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s"
               data-wow-offset="40" v-if="course.description">
          <h4>Sobre o curso</h4>
          <div
            :class="fullDescription || course.description.length <= 1490 ? 'active render-content' : 'render-content'">
            <p v-html="course.description"></p>
            <v-btn v-if="course.description.length > 1490" class="outline w100" color="primary" dark
                   @click="fullDescription = !fullDescription">
              <template v-if="fullDescription">
                Ver menos
              </template>
              <template v-else>
                Ver descrição completa
              </template>
            </v-btn>
          </div>
        </v-col>-->
      </v-row>
    </div>

    <v-dialog
      v-model="dialogVideo.show"
      max-width="800"
    >
      <div class="black" v-if="!dialogVideo.error">
        <div class="video video-modal">
          <div
            id="player"
            ref="player"
          />
        </div>
      </div>
      <v-card v-else>
        <v-card-text class="red text-center pt-3 error">
          Erro ao carregar o vídeo
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Player from '@vimeo/player'
import { CourseModel } from '@/models/Course'

// function Course (title, description, price, priceWithTax, isPublic, videoIntro, modules, contents, user) {
//   this.title = title
//   this.description = description
//   this.price = price
//   this.priceWithTax = priceWithTax
//   this.isPublic = isPublic
//   this.videoIntro = videoIntro
//   this.modules = modules
//   this.contents = contents
//   this.user = user
// }

export default {
  name: 'CoursePage',
  data () {
    return {
      dialogVideo: {
        show: false,
        vimeoId: '',
        player: null,
        loading: false,
        error: false,
      },
      titleDescription: 'Sobre o curso',
      description: '',
      fullDescription: false,
      showDescription: false,
    }
  },
  props: {
    course: CourseModel
  },
  watch: {
    'dialogVideo.show' (val) {
      if (!val) {
        this.destroyVimeoPlayer()
      }
    }
  },
  created () {
    if (this.course.description) {
      this.description = this.course.description
      this.showDescription = true
    }

    if (this.course.videoIntro && this.course.videoIntro.vimeoStatus === 'complete') {
      setTimeout(() => {
        new Player('playerInfo', {
          id: this.course.videoIntro.vimeoId
        })
      }, 0)
    }

  },
  methods: {
    openContent (content) {
      if (!content.isPublic) {
        return false
      }

      if (content.type === 1) {
        if (!content.vimeoId) {
          return false
        }

        this.dialogVideo.title = content.title
        this.dialogVideo.vimeoId = content.vimeoId
        this.dialogVideo.loading = true
        this.dialogVideo.show = true

        setTimeout(() => {
          // this.dialogVideo.player = new Player(this.$refs.player, {
          //   id: dialogVideo.vimeoId
          // })

          this.dialogVideo.player = new Player('player', {
            id: content.vimeoId
          })

          this.dialogVideo.player.loadVideo(content.vimeoId).then(() => {
            this.dialogVideo.error = false
          }).catch(err => {
            console.error(err)

            this.dialogVideo.error = true
          }).finally(() => {
            this.dialogVideo.loading = false
          })

          // this.dialogVideo.player.on('loaded', () => {
          //   console.log('carregou loaded')
          //
          //   this.dialogVideo.loading = false
          //   this.dialogVideo.error = false
          // })
          //
          // this.dialogVideo.player.on('error', data => {
          //   console.log('error loaded', data)
          //
          //   this.dialogVideo.loading = false
          //   this.dialogVideo.error = true
          // })
        }, 0)
      }

      if (content.type === 2) {
        this.titleDescription = content.title
        this.description = content.description
        this.showDescription = true
      }
    },
    destroyVimeoPlayer () {
      setTimeout(() => {
        this.dialogVideo.error = false
        this.dialogVideo.loading = false
        if (this.dialogVideo.player) {
          this.dialogVideo.player.destroy()
        }
      }, 250)
    },

  }
}
</script>

